// 检查类型
export enum CheckType {
  LIQUEFIED_GAS    = 'liquefied_gas',    // 瓶装液化石油气（用户端）
  NATURAL_GAS      = 'natural_gas',      // 管道天然气（用户端）
  LPG_DEPOT        = 'lpg_depot',        // 液化石油气储配站
  LNG_GASIFICATION = 'lng_gasification', // LNG 气化站
  LNG_FILLING      = 'lng_filling',      // LNG 加气站
  GATE_PRESSURE    = 'gate_pressure',    // 天然气门站/调压站
}

// 隐患级别
export enum HazardLevel {
  MAJOR = 'major',      // 重大隐患
  GENERAL = 'general'   // 一般隐患
}

// 检查项目
export interface CheckItem {
  id: string
  name: string
  checkType: CheckType
  hazardLevel: HazardLevel
  isCustom: boolean
  createdAt: Date
  regulatoryBasis?: string
}

// 检查记录
export interface CheckRecord {
  id: string
  checkType: CheckType
  inspectedUnit: string
  inspectedAddress: string
  inspector: string
  checkDate: Date
  selectedItems: CheckItem[]
  summary?: CheckSummary
  report?: Report
  riskLevel: 'high' | 'medium' | 'low'
  createdAt: Date
  updatedAt: Date
  // 场站专属字段（可选）
  stationManager?: string
  lastInspectionDate?: string
}

// 检查总结
export interface CheckSummary {
  overview: string
  majorHazards: string[]
  generalHazards: string[]
  suggestions: string[]
  generatedAt: Date
}

// 处理建议项
export interface HandlingItem {
  handlingType: string
  specificMeasure: string
  executionDeadline: string
  supervisoryUnit: string
}

// 报告
export interface Report {
  id: string
  checkRecordId: string
  reportNumber: string
  content: string
  inspectorSignature?: string
  unitRepresentativeSignature?: string
  generatedAt: Date
}

// 检查配置
export interface CheckConfig {
  checkType: CheckType | null
  inspectedUnit: string
  inspectedAddress: string
  inspector: string
  // 场站专属字段（可选）
  stationManager?: string
  lastInspectionDate?: string
}

// 当前检查状态
export interface CurrentCheckState {
  config: CheckConfig
  selectedItems: CheckItem[]
  customItems: CheckItem[]
}

// 部门配置（首次使用时设置，之后所有报告自动使用）
export interface DepartmentConfig {
  cityName: string
  departmentName: string
  shortName: string
}
